import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GetLoyaltyCollectionsResponseDto } from '@src/api';
import { BaseResizableComponent } from '@src/app/modules/base';
import { LoyaltyProgramCategory } from '@src/app/modules/loyalty-program/models';

@Component({
  selector: 'lp-collection-item',
  templateUrl: './collection-item.component.html',
  styleUrls: ['./collection-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpCollectionItemComponent extends BaseResizableComponent {
  @Input() item?: GetLoyaltyCollectionsResponseDto;
  @Input() loading = false;

  get banner(): LoyaltyProgramCategory | undefined {
    if (!this.item?.id) return;

    return { id: this.item.id, imageId: this.item?.bannerBackgroundPhotoId, name: this.item.bannerTitle ?? '' };
  }
}
